/* edge-r-home.js: behaviour for the edge-r homepage and shared sections.
   Loaded with defer by each section that needs it; runs once per page (guard below) and wires every
   [data-edge-r] root, plus any section the theme editor adds later (shopify:section:load).
   Carousels move only when the visitor moves them. Looping videos and CSS loops pause off-screen. */
(function () {
  'use strict';
  if (window.EdgeRHome) return;

  var d = document, html = d.documentElement;
  var REDUCE = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var SAVE = navigator.connection && navigator.connection.saveData;
  var HAS_IO = 'IntersectionObserver' in window;
  var BEHAV = REDUCE ? 'auto' : 'smooth';
  function $(sel, root) { return (root || d).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || d).querySelectorAll(sel)); }
  function onView(el, cb, opts) {
    if (!HAS_IO) { cb(true); return null; }
    var io = new IntersectionObserver(function (es) { cb(es[es.length - 1].isIntersecting, es[es.length - 1]); }, opts || {});
    io.observe(el); return io;
  }

  /* ---------- reveal on scroll ---------- */
  // Hidden-until-seen only starts once this script runs, and anything already on screen is shown at once,
  // so nothing in the first viewport ever starts invisible.
  function initReveal(root) {
    var els = $$('.er-reveal, [data-er-bars], [data-er-draw]', root);
    if (!els.length) return;
    if (REDUCE || !HAS_IO) { els.forEach(function (el) { el.classList.add('in'); }); return; }
    var vh = window.innerHeight || html.clientHeight;
    els.forEach(function (el) { var r = el.getBoundingClientRect(); if (r.top < vh * 1.1) el.classList.add('in'); });
    html.classList.add('er-anim');
    var io = new IntersectionObserver(function (es) {
      var i = 0;
      es.forEach(function (en) {
        if (en.isIntersecting || en.boundingClientRect.top < 0) {
          var el = en.target; el.style.transitionDelay = (Math.min(i, 3) * 70) + 'ms'; i++;
          el.classList.add('in'); io.unobserve(el);
        }
      });
    }, { rootMargin: '0px 0px 25% 0px', threshold: 0 });
    els.forEach(function (el) { if (!el.classList.contains('in')) io.observe(el); });
  }

  /* ---------- hero: poster first, then the muted loop ---------- */
  // The <video> is in the HTML with its phone/desktop <source media> picked by the browser, but its sources only
  // get src after the poster <picture> has loaded and painted (plus an idle moment), so the poster is the LCP.
  // The video stays visibility:hidden until it is really playing, and takes the poster's own URL as its poster.
  function initHero(root) {
    var box = $('[data-er-hero-media]', root), btn = $('[data-er-vid-toggle]', root);
    var v = box && $('video', box);
    if (!v || !btn) return;
    var ip = $('[data-er-ico-pause]', btn), ipl = $('[data-er-ico-play]', btn), img = $('picture img', box);
    var loaded = false, userPaused = false, autoPaused = false, inView = true;
    v.muted = true; v.defaultMuted = true; v.playsInline = true;
    function setIcon(playing) {
      ip.style.display = playing ? '' : 'none'; ipl.style.display = playing ? 'none' : '';
      btn.setAttribute('aria-label', playing ? 'Pause video' : 'Play video');
    }
    function tryPlay() { var p = v.play(); if (p && p.catch) p.catch(function () { setIcon(false); }); setIcon(true); }
    function load() {
      if (loaded) return; loaded = true;
      if (img && img.currentSrc) v.poster = img.currentSrc;
      $$('source[data-src]', v).forEach(function (s) { s.src = s.getAttribute('data-src'); });
      v.load();
      if (!userPaused) tryPlay();
    }
    v.addEventListener('playing', function () { v.classList.add('is-playing'); if (!inView || d.hidden) sync(); });
    v.addEventListener('timeupdate', function () { if (v.duration) btn.style.setProperty('--p', (v.currentTime / v.duration).toFixed(3)); });
    function sync() {
      if (!loaded) return;
      if (!inView || d.hidden) { if (!v.paused) { v.pause(); autoPaused = true; } }
      else if (autoPaused && !userPaused) { autoPaused = false; tryPlay(); }
    }
    btn.hidden = false;
    btn.addEventListener('click', function () {
      if (!loaded) { userPaused = false; load(); return; }
      autoPaused = false;
      if (v.paused) { userPaused = false; tryPlay(); } else { userPaused = true; v.pause(); setIcon(false); }
    });
    d.addEventListener('visibilitychange', sync);
    onView(box, function (vis) { inView = vis; sync(); });
    if (REDUCE || SAVE) { setIcon(false); return; } // poster only; the button starts the loop
    function start() {
      // Poster painted (2 frames), then 1 s, then an idle moment: the video can never paint before the poster (Lane 28, 2026-10-05).
      requestAnimationFrame(function () { requestAnimationFrame(function () {
        setTimeout(function () {
          (window.requestIdleCallback || function (f) { setTimeout(f, 200); })(load, { timeout: 2000 });
        }, 1000);
      }); });
    }
    if (!img || img.complete) { if (d.readyState === 'complete') start(); else window.addEventListener('load', start, { once: true }); }
    else { img.addEventListener('load', start, { once: true }); img.addEventListener('error', start, { once: true }); }
  }

  /* ---------- problem: "See for yourself" brings the game into view ---------- */
  function initProblem(root) {
    var a = $('[data-er-see-game]', root); if (!a) return;
    a.addEventListener('click', function (e) {
      var g = d.getElementById('edge-r-game') || $('[id$="__edge_r_game"]') || $('.edge-r-game') || d.getElementById('scrapeGame');
      if (!g) return;
      e.preventDefault();
      var stage = $('.esg-stage', g) || g;
      stage.scrollIntoView({ behavior: BEHAV, block: 'center' });
      setTimeout(function () { if (window.edgeScrapeGame && window.edgeScrapeGame.nudge) window.edgeScrapeGame.nudge(); }, REDUCE ? 0 : 450);
    });
  }

  /* ---------- compare: bull nose clips play together, only on screen ---------- */
  function initCompare(root) {
    var wrap = $('[data-er-bn]', root); if (!wrap) return;
    var vids = $$('video', wrap); if (!vids.length) return;
    var btn = $('[data-er-bn-toggle]', wrap), inView = false, userOff = REDUCE, restartT = 0;
    vids.forEach(function (v) { v.muted = true; v.defaultMuted = true; v.loop = false; v.playsInline = true; });
    // Clip stills load only when the section is within about one screen (they used to download with the hero poster).
    var posted = false;
    function setPosters() { if (posted) return; posted = true; vids.forEach(function (v) { var u = v.getAttribute('data-poster'); if (u) v.poster = u; }); }
    if (HAS_IO) { var pio = new IntersectionObserver(function (es) { if (es.some(function (e) { return e.isIntersecting; })) { setPosters(); pio.disconnect(); } }, { rootMargin: '800px 0px' }); pio.observe(wrap); } else setPosters();
    var lead = vids[vids.length - 1];
    function should() { return inView && !d.hidden && !userOff; }
    function playAll() {
      vids.forEach(function (v) {
        if (v.preload === 'none') v.preload = 'auto';
        if (v !== lead && Math.abs(v.currentTime - lead.currentTime) > 0.08 && !lead.ended) { try { v.currentTime = lead.currentTime; } catch (e) {} }
        var p = v.play(); if (p && p.catch) p.catch(function () {});
      });
    }
    function pauseAll() { vids.forEach(function (v) { v.pause(); }); }
    function restart() { clearTimeout(restartT); restartT = 0; vids.forEach(function (v) { try { v.currentTime = 0; } catch (e) {} }); if (should()) playAll(); }
    vids.forEach(function (v) {
      v.addEventListener('ended', function () {
        if (vids.every(function (x) { return x.ended; })) restart();
        else if (!restartT) restartT = setTimeout(restart, 250);
      });
    });
    function setBtn() {
      if (!btn) return;
      btn.textContent = userOff ? 'Play' : 'Pause';
      btn.setAttribute('aria-pressed', String(!userOff));
      btn.setAttribute('aria-label', userOff ? 'Play the comparison' : 'Pause the comparison');
    }
    function update() { if (should()) playAll(); else pauseAll(); setBtn(); }
    if (btn) btn.addEventListener('click', function () { userOff = !userOff; update(); });
    d.addEventListener('visibilitychange', update);
    onView(wrap, function (vis) { inView = vis; update(); }, { threshold: 0.2 });
    setBtn();
  }

  /* ---------- how: steps drive the pinned photo; hold tabs ---------- */
  function initHow(root) {
    var steps = $$('.er-step', root), imgs = $$('.er-story-media img', root), tag = $('[data-er-story-tag]', root), rail = $('[data-er-story-rail]', root);
    var names = ['1 · Snow', '2 · Ice', '3 · Stow and go'];
    function set(i) {
      steps.forEach(function (s, k) { s.classList.toggle('on', k === i); s.classList.toggle('done', k < i); });
      imgs.forEach(function (m) { m.classList.toggle('on', +m.getAttribute('data-s') === i); });
      if (tag) tag.textContent = names[i];
      if (rail) rail.style.setProperty('--sp', ((i + 1) / 3 * 100) + '%');
    }
    if (HAS_IO && steps.length) {
      var so = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) set(+e.target.dataset.step); }); }, { rootMargin: '-45% 0px -45% 0px' });
      steps.forEach(function (s) { so.observe(s); });
    }
    var holds = $('[data-er-holds]', root); if (!holds) return;
    var tabs = $$('[role="tab"]', holds), panels = $$('[role="tabpanel"]', holds), himgs = $$('.er-hold-img img', holds);
    function show(i, focus) {
      tabs.forEach(function (t, k) { var on = k === i; t.setAttribute('aria-selected', on ? 'true' : 'false'); t.tabIndex = on ? 0 : -1; });
      panels.forEach(function (p, k) { p.hidden = k !== i; });
      himgs.forEach(function (m) { m.classList.toggle('on', +m.getAttribute('data-hi') === i); });
      if (focus) tabs[i].focus();
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { show(i); });
      t.addEventListener('keydown', function (e) {
        var n = null;
        if (e.key === 'ArrowRight') n = (i + 1) % tabs.length;
        if (e.key === 'ArrowLeft') n = (i - 1 + tabs.length) % tabs.length;
        if (e.key === 'Home') n = 0;
        if (e.key === 'End') n = tabs.length - 1;
        if (n !== null) { e.preventDefault(); show(n, true); }
      });
    });
  }

  /* ---------- no handle: click to play ---------- */
  function initNoHandle(root) {
    var m = $('[data-er-nh]', root), b = $('[data-er-nh-play]', root), v = m && $('video', m);
    if (!b || !v) return;
    b.addEventListener('click', function () {
      if (!v.getAttribute('src')) v.src = v.dataset.src;
      m.classList.add('playing'); v.controls = true;
      var p = v.play(); if (p && p.catch) p.catch(function () {});
    });
    onView(m, function (vis) { if (!vis && !v.paused) v.pause(); });
  }

  /* ---------- parts: list <-> hotspots ---------- */
  function initParts(root) {
    var hss = $$('.er-hs', root), items = $$('.er-parts-list button', root), viewer = $('[data-er-viewer]', root);
    function light(part) {
      hss.forEach(function (h) { var on = h.dataset.part === part || (part === 'triforce' && (h.dataset.part === 'bull' || h.dataset.part === 'reach')); h.classList.toggle('lit', on); });
      items.forEach(function (b) { b.classList.toggle('lit', b.dataset.part === part); });
    }
    hss.forEach(function (h) {
      h.addEventListener('click', function () {
        var o = !h.classList.contains('open');
        hss.forEach(function (x) { x.classList.remove('open'); x.setAttribute('aria-expanded', 'false'); });
        if (o) { h.classList.add('open'); h.setAttribute('aria-expanded', 'true'); light(h.dataset.part); }
      });
      h.addEventListener('mouseenter', function () { light(h.dataset.part); });
    });
    items.forEach(function (b) {
      b.addEventListener('click', function () { light(b.dataset.part); if (window.innerWidth < 900 && viewer) viewer.scrollIntoView({ behavior: BEHAV, block: 'center' }); });
      b.addEventListener('mouseenter', function () { light(b.dataset.part); });
    });
  }

  /* ---------- buy: packs, gallery, add to cart, phone sticky bar ---------- */
  function initBuy(root) {
    var form = $('[data-er-buy-form]', root); if (!form) return;
    var radios = $$('input[name="id"]', form), addBtn = $('[data-er-add]', form), addLbl = $('[data-er-add-label]', form);
    var sumTotal = $('[data-er-sum-total]', root), sumEach = $('[data-er-sum-each]', root), sumShip = $('[data-er-sum-ship]', root);
    var meter = $('[data-er-meter]', root), meterTxt = $('[data-er-meter-txt]', root), err = $('[data-er-buy-error]', root);
    var sticky = $('[data-er-sticky]', root), stickyName = $('[data-er-sticky-name]', root);
    var baseLabel = (addLbl.textContent.split(' · ')[0] || '').trim();
    function current() { return $('input[name="id"]:checked', form); }
    function sync(bump) {
      var r = current(); if (!r) { addBtn.disabled = true; return; }
      var n = +r.dataset.units;
      addLbl.textContent = baseLabel + ' · ' + r.dataset.price;
      sumTotal.textContent = r.dataset.price; sumEach.textContent = r.dataset.each; sumShip.textContent = r.dataset.ship;
      meter.style.setProperty('--m', (n >= 2 ? 100 : 50) + '%'); meter.classList.toggle('full', n >= 2);
      meterTxt.textContent = n >= 2 ? root.dataset.meterFree : root.dataset.meterOne;
      if (stickyName) stickyName.textContent = (n === 1 ? 'The EDGE' : 'The EDGE · ' + r.dataset.short) + ' · ' + r.dataset.price;
      if (bump && !REDUCE) { sumTotal.classList.remove('er-bump'); void sumTotal.offsetWidth; sumTotal.classList.add('er-bump'); }
    }
    radios.forEach(function (r) { r.addEventListener('change', function () { sync(true); }); });
    sync(false);

    var cart = d.querySelector('cart-drawer') || d.querySelector('cart-notification');
    if (cart) addBtn.setAttribute('aria-haspopup', 'dialog');
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (addBtn.getAttribute('aria-disabled') === 'true') return;
      var r = current(); if (!r) return;
      err.hidden = true; err.textContent = '';
      addBtn.setAttribute('aria-disabled', 'true');
      var fd = new FormData();
      fd.append('id', r.value); fd.append('quantity', '1');
      if (cart && cart.getSectionsToRender) {
        fd.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
        fd.append('sections_url', window.location.pathname);
        if (cart.setActiveElement) cart.setActiveElement(addBtn);
      }
      var url = ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';
      fetch(url, { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body: fd })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          if (data.status) { err.textContent = data.description || data.message || ''; err.hidden = !err.textContent; return; }
          if (!cart || !cart.renderContents) { window.location = (window.routes && window.routes.cart_url) || '/cart'; return; }
          if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
            try { window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'edge-r-buy', productVariantId: r.value, cartData: data }); } catch (x) {}
          }
          cart.renderContents(data);
          if (cart.classList && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        })
        .catch(function () { window.location = (window.routes && window.routes.cart_url) || '/cart'; })
        .finally(function () { addBtn.removeAttribute('aria-disabled'); });
    });

    // gallery
    var g = $('[data-er-gallery]', root);
    if (g) {
      var slides = $$('.er-g-slide', g), thumbs = $$('.er-g-thumb', root), count = $('[data-er-g-count]', g), gi = 0;
      function stopVideos() { $$('video', g).forEach(function (v) { v.pause(); }); }
      function showG(i) {
        gi = (i + slides.length) % slides.length;
        stopVideos();
        slides.forEach(function (s, k) { s.hidden = k !== gi; });
        thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === gi ? 'true' : 'false'); });
        if (count) count.textContent = (gi + 1) + ' / ' + slides.length;
      }
      thumbs.forEach(function (t, i) { t.addEventListener('click', function () { showG(i); }); });
      var pv = $('.er-g-prev', g), nx = $('.er-g-next', g);
      if (pv) pv.addEventListener('click', function () { showG(gi - 1); });
      if (nx) nx.addEventListener('click', function () { showG(gi + 1); });
      $$('[data-er-g-video]', g).forEach(function (s) {
        var v = $('video', s), b = $('.er-g-play', s); if (!v || !b) return;
        b.addEventListener('click', function () { if (!v.getAttribute('src')) v.src = v.dataset.src; s.classList.add('playing'); var p = v.play(); if (p && p.catch) p.catch(function () {}); });
      });
      var sx = null;
      g.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      g.addEventListener('touchend', function (e) { if (sx === null) return; var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 40) showG(gi + (dx < 0 ? 1 : -1)); sx = null; });
      onView(g, function (vis) { if (!vis) stopVideos(); });
    }

    // phone sticky bar: after the hero button scrolls away; hidden over the picker and the footer
    if (sticky && HAS_IO) {
      var heroCta = d.querySelector('[data-er-hero-cta]'), foot = d.querySelector('footer, #shopify-section-footer, [id$="__footer"]');
      var st = { hero: !!heroCta, buy: false, foot: false };
      var link = $('a', sticky);
      function upd() {
        var show = !st.hero && !st.buy && !st.foot;
        sticky.classList.toggle('show', show); sticky.setAttribute('aria-hidden', show ? 'false' : 'true'); link.tabIndex = show ? 0 : -1;
      }
      var so = new IntersectionObserver(function (es) {
        es.forEach(function (en) {
          if (en.target === heroCta) st.hero = en.isIntersecting || en.boundingClientRect.top > 0;
          else if (en.target === root) st.buy = en.isIntersecting;
          else st.foot = en.isIntersecting;
        });
        upd();
      });
      if (heroCta) so.observe(heroCta);
      so.observe(root);
      if (foot) so.observe(foot);
    }
  }

  /* ---------- carousels: scroll-snap, arrows, progress, drag, keys; never autoplay ---------- */
  function initCarousel(c) {
    if (c.__erCar) return; c.__erCar = true;
    var track = $('.er-car-track', c), items = $$('.er-car-item', track);
    var prev = $('.er-car-prev', c), next = $('.er-car-next', c), prog = $('.er-car-prog i', c);
    if (!track || !items.length) return;
    function step() { var gap = parseFloat(getComputedStyle(track).columnGap) || 16; return items[0].getBoundingClientRect().width + gap; }
    function idx() { return Math.round(track.scrollLeft / step()); }
    function go(i) { track.scrollTo({ left: Math.max(0, i) * step(), behavior: BEHAV }); }
    function sync() {
      var max = track.scrollWidth - track.clientWidth, f = max > 0 ? track.scrollLeft / max : 0, vis = Math.max(12, track.clientWidth / track.scrollWidth * 100);
      if (prog) { prog.style.width = vis + '%'; prog.style.marginLeft = (f * (100 - vis)) + '%'; }
      if (prev) prev.disabled = track.scrollLeft <= 4;
      if (next) next.disabled = track.scrollLeft >= max - 4;
    }
    if (prev) prev.addEventListener('click', function () { go(idx() - 1); });
    if (next) next.addEventListener('click', function () { go(idx() + 1); });
    var raf; track.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(sync); }, { passive: true });
    track.addEventListener('keydown', function (e) {
      if (e.target !== track) return;
      if (e.key === 'ArrowRight') { e.preventDefault(); go(idx() + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(idx() - 1); }
    });
    var down = false, sx = 0, sl = 0, moved = false;
    track.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse' || e.button !== 0) return; down = true; moved = false; sx = e.clientX; sl = track.scrollLeft; });
    window.addEventListener('pointermove', function (e) { if (!down) return; var dx = e.clientX - sx; if (Math.abs(dx) > 5) { moved = true; track.classList.add('dragging'); } if (moved) track.scrollLeft = sl - dx; });
    window.addEventListener('pointerup', function () { if (!down) return; down = false; if (moved) { track.classList.remove('dragging'); go(idx()); } });
    track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
    window.addEventListener('resize', sync); sync();
  }

  /* ---------- drop: card tilt, lightbox, countdown ---------- */
  function initDrop(root) {
    if (!REDUCE && window.matchMedia('(hover:hover)').matches) {
      $$('.er-drop', root).forEach(function (el) {
        var card = $('.er-card', el), ph = $('.er-ph', el);
        el.addEventListener('pointermove', function (e) {
          var r = el.getBoundingClientRect(), x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
          card.style.setProperty('--ry', ((x - .5) * 10) + 'deg'); card.style.setProperty('--rx', ((.5 - y) * 8) + 'deg');
          ph.style.setProperty('--gx', (x * 100) + '%'); ph.style.setProperty('--gy', (y * 100) + '%');
        });
        el.addEventListener('pointerleave', function () { card.style.setProperty('--ry', '0deg'); card.style.setProperty('--rx', '0deg'); });
      });
    }
    var lb = $('[data-er-lb]', root), cards = $$('[data-er-lightbox]', root), cur = 0;
    if (lb && cards.length) {
      var li = $('[data-er-lb-img]', lb), ln = $('[data-er-lb-name]', lb), lp = $('[data-er-lb-price]', lb), ll = $('[data-er-lb-link]', lb);
      function showD(i) {
        cur = (i + cards.length) % cards.length; var c = cards[cur];
        var upd = function () { if (c.dataset.full) li.src = c.dataset.full; li.alt = c.dataset.alt || ''; ln.textContent = c.dataset.name; lp.textContent = c.dataset.price; ll.href = c.dataset.url; };
        if (d.startViewTransition && !REDUCE && lb.open) d.startViewTransition(upd); else upd();
      }
      cards.forEach(function (c, i) { c.addEventListener('click', function () { showD(i); if (lb.showModal) lb.showModal(); else lb.setAttribute('open', ''); }); });
      $('.er-lb-prev', lb).addEventListener('click', function () { showD(cur - 1); });
      $('.er-lb-next', lb).addEventListener('click', function () { showD(cur + 1); });
      $('.er-lb-close', lb).addEventListener('click', function () { lb.close(); });
      lb.addEventListener('click', function (e) { if (e.target === lb) lb.close(); });
      lb.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') showD(cur + 1); if (e.key === 'ArrowLeft') showD(cur - 1); });
    }
    /* Next Drop bar (Lane 21, 2026-10-07): show the first scheduled Drop still ahead, count down to it, roll to the next line when it passes, hide the bar when none is left. */
    var nd = $('[data-er-next-drop]', root), cd = $('[data-er-countdown]', root);
    if (nd && cd) {
      var rows = $$('[data-nd-at]', nd), dd = $('[data-cd-d]', cd), hh = $('[data-cd-h]', cd), mm = $('[data-cd-m]', cd), t = NaN, timer;
      var pick = function () {
        var now = Date.now(), on = null;
        rows.forEach(function (r) {
          var at = r.getAttribute('data-nd-at'), ms = at ? new Date(at).getTime() : NaN;
          var ok = !on && (at ? (!isNaN(ms) && ms > now) : true);
          r.hidden = !ok; if (ok) { on = r; t = ms; }
        });
        nd.style.display = on ? '' : 'none';
        if (on) { var off = $('style[data-nd-off]', root); if (off) off.remove(); }
        cd.hidden = !(on && !isNaN(t));
        return !!(on && !isNaN(t));
      };
      var tick = function () {
        var s = (t - Date.now()) / 1000;
        if (s <= 0) { if (!pick()) { clearInterval(timer); return; } s = (t - Date.now()) / 1000; }
        dd.textContent = Math.floor(s / 86400); hh.textContent = String(Math.floor(s % 86400 / 3600)).padStart(2, '0'); mm.textContent = String(Math.floor(s % 3600 / 60)).padStart(2, '0');
      };
      if (pick()) { tick(); timer = setInterval(tick, 30000); }
    }
  }

  /* ---------- FAQ: animated open and close ---------- */
  function initFaq(root) {
    $$('details', root).forEach(function (det) {
      var sum = $('summary', det), ans = $('.er-ans', det), busy = false;
      if (!sum || !ans) return;
      sum.addEventListener('click', function (e) {
        if (REDUCE || !ans.animate) return;
        e.preventDefault(); if (busy) return; busy = true;
        if (det.open) {
          var h = ans.offsetHeight;
          ans.animate([{ height: h + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], { duration: 260, easing: 'cubic-bezier(.2,.7,.2,1)' }).onfinish = function () { det.open = false; busy = false; };
        } else {
          det.open = true; var h2 = ans.offsetHeight;
          ans.animate([{ height: '0px', opacity: 0 }, { height: h2 + 'px', opacity: 1 }], { duration: 300, easing: 'cubic-bezier(.2,.7,.2,1)' }).onfinish = function () { busy = false; };
        }
      });
    });
  }

  /* ---------- off-screen pause for looping CSS animations ---------- */
  function initOffscreenPause() {
    var ATTR = 'data-er-anim-off';
    var st = d.createElement('style');
    st.textContent = '[' + ATTR + '],[' + ATTR + ']::before,[' + ATTR + ']::after{animation-play-state:paused!important}';
    d.head.appendChild(st);
    if (!HAS_IO || !d.getAnimations) return;
    var seen = new Map();
    function apply(el) { if (d.hidden || seen.get(el) === false) el.setAttribute(ATTR, ''); else el.removeAttribute(ATTR); }
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { seen.set(e.target, e.isIntersecting); apply(e.target); }); }, { rootMargin: '64px 0px' });
    function scan() {
      d.getAnimations().forEach(function (a) {
        if (typeof a.animationName !== 'string' || !a.effect || !a.effect.getTiming || a.effect.getTiming().iterations !== Infinity) return;
        var el = a.effect.target;
        if (!el || el.nodeType !== 1 || seen.has(el) || !el.closest('.edge-r, .edge-r-hero')) return;
        seen.set(el, true); io.observe(el);
      });
    }
    var q = 0;
    d.addEventListener('animationstart', function () { if (q) return; q = setTimeout(function () { q = 0; scan(); }, 60); }, true);
    d.addEventListener('visibilitychange', function () { seen.forEach(function (v, el) { apply(el); }); });
    scan();
  }

  var INITS = { hero: initHero, problem: initProblem, compare: initCompare, how: initHow, 'no-handle': initNoHandle, parts: initParts, buy: initBuy, drop: initDrop, faq: initFaq };
  function initRoot(root) {
    if (!root || root.__erInit) return; root.__erInit = true;
    var fn = INITS[root.getAttribute('data-edge-r')];
    try { if (fn) fn(root); } catch (e) { if (window.console) console.error(e); }
    $$('[data-er-carousel]', root).forEach(initCarousel);
    initReveal(root);
  }
  function initAll() { $$('[data-edge-r]').forEach(initRoot); }

  window.EdgeRHome = { init: initAll, initRoot: initRoot };
  function boot() { initAll(); initOffscreenPause(); }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot); else boot();
  d.addEventListener('shopify:section:load', function (e) { var r = e.target && e.target.querySelector('[data-edge-r]'); if (r) initRoot(r); });
})();
